// Task 24498 - the Maps key is read from the environment, falling back to the
// value that was hardcoded here.
//
// The fallback keeps every existing build working untouched. The environment
// variable is what matters: when the key has to change - and it does, because
// the current project's billing is what put the "For development purposes
// only" watermark across every map (see helpers/functions/googleMapsAuth.js) -
// rotating it should be a deployment setting, not a code change and a release.
//
// Worth knowing: a browser Maps key is NOT a secret. It ships in the bundle
// and anyone can read it, which is why Google's protection for it is an
// HTTP-referrer restriction on the key itself rather than hiding the string.
// So this is about being able to change it, not about concealing it - but it
// is also why the key should be referrer-restricted in the Cloud console to
// the CRMit hostnames, or someone else's site can spend the billing.
export const GoogleApiKey =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyDagd6lqTXErZY4icCoK8oanWxXFyi3Dj8";
